import { getConfiguration } from 'service/ConfigAPI/index';

/**
 *
 * @param level {string} - operating level
 * @param level_id {string|number} - operating level id
 * @param type {string} - configuration type
 * @param name {string} - configuration name
 * @param lookDeeper {boolean} - flag indicating if CAFA should be checking for configuration with the same name and type in higher operating levels
 * @returns {Promise<T | {data: {}, err: Error | null}>}
 */

export const fetchConfiguration = ({
  level,
  level_id,
  type,
  name,
  lookDeeper,
}) =>
  getConfiguration({
    level,
    level_id,
    type,
    name,
    lookDeeper,
  })
    .then((response) => {
      if (response.data && response.data[0] && response.data[0].value) {
        return { data: response.data[0], err: null };
      }
      return { data: {}, err: null };
    })
    .catch((err) => ({ data: {}, err }));
